"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var QrCode = __importStar(require("./qrCode"));
var ProgressGroupWithParagraph = __importStar(require("./O_ProgressGroupWithParagraph"));
var Component = function (p) {
    return (Preact.h(Box_1.default, { sx: {
            padding: '26px',
            backgroundColor: 'background.default',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        } },
        Preact.h(Typography_1.default, { variant: "body1", sx: { paddingBottom: '26px', textAlign: 'center' } }, p.arHeader),
        p.url ? (Preact.h(Box_1.default, { paddingBottom: "26px" },
            Preact.h(QrCode.Component, { url: p.url, size: 136 }))) : (Preact.h(Box_1.default, { sx: { alignSelf: 'stretch', padding: 0 } },
            Preact.h(ProgressGroupWithParagraph.Component, { statusText: p.qrLoading, sx: { paddingBottom: '0px' } }))),
        Preact.h(Box_1.default, null,
            Preact.h("img", { src: p.img, style: "border-radius:8px" }))));
};
exports.Component = Component;
